var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import id from "@irati/utils/id";
import { greys } from "../global/colors";
import StyledBanner from "./styled/Banner";
import CutOffTriangle from "./styled/CutOffTriangle";
var Banner = /** @class */ (function (_super) {
    __extends(Banner, _super);
    function Banner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Banner.prototype.render = function () {
        var _a = this.props, backgroundColor = _a.backgroundColor, backgroundPosition = _a.backgroundPosition, backgroundSize = _a.backgroundSize, tabletBackgroundPosition = _a.tabletBackgroundPosition, tabletBackgroundSize = _a.tabletBackgroundSize, bannerImg = _a.bannerImg, children = _a.children, minHeight = _a.minHeight, tabletMinHeight = _a.tabletMinHeight, cutOffBottom = _a.cutOffBottom, className = _a.className;
        var idNamespace = id("perkbox-banner", this.props);
        return (React.createElement(StyledBanner, { id: idNamespace, backgroundColor: backgroundColor, backgroundPosition: backgroundPosition, backgroundSize: backgroundSize, tabletBackgroundPosition: tabletBackgroundPosition, tabletBackgroundSize: tabletBackgroundSize, minHeight: minHeight, tabletMinHeight: tabletMinHeight, src: bannerImg, className: className },
            children,
            cutOffBottom && React.createElement(CutOffTriangle, null)));
    };
    Banner.defaultProps = {
        backgroundColor: greys.black,
        backgroundPosition: "top center",
        backgroundSize: "cover",
        tabletBackgroundPosition: "top center",
        tabletBackgroundSize: "cover",
        minHeight: 340,
        tabletMinHeight: 340,
        cutOffBottom: false,
        className: null
    };
    return Banner;
}(PureComponent));
export default Banner;
